// The silhouette a product is cut along — one per product, not per side.
//
// Deliberately not an AField. The previous model subclassed ImageField, inheriting
// position, rotation, scale, opacity, frameSize and isLocked, none of which the renderer
// honoured: the cut group's left/top are computed from the canvas, its transform is never
// mutated, and it is not selectable. A subtype that silently ignores most of its parent's
// contract is exactly the substitutability failure to avoid, so the shape now carries only
// what is actually read — where to fetch it from, and where its SVG currently lives.
//
// Sides are a rendering concern, not part of the shape: recto and verso draw the same
// silhouette, the verso mirrored. That is a paint option, not a second entity.
class CuttingShape {
    // Backend asset id. Also the memoisation key for the fetched SVG.
    readonly uuid: string;

    // Blob URL for the fetched SVG. Lives as long as the memoised entry.
    readonly url: string;

    constructor({ url, uuid }: { url: string; uuid: string }) {
        this.url = url;
        this.uuid = uuid;
    }
}

export { CuttingShape };
